<ripple
  [size]="size"
  [flexCenter]="flexCenter"
  [positionRelative]="positionRelative"
  [isFullPage]="isFullPage"
></ripple>
